export default __webpack_public_path__ + "static/media/image3.13341f4e.jpg";